<template>
    <v-card>
        <v-form v-model="valid" ref="DeliveryInfoForm" @submit.prevent>
            <v-card-title>
              <v-icon>local_shipping</v-icon>
              <span class="subtitle-1 font-weight-bold ml-2">Delivery Information</span>
            </v-card-title>
            <v-card-text>
                <v-row v-if="error">
                    <v-col cols="12">
                        <v-icon left color="error" class="mr-2">announcement</v-icon>
                        <span class="error--text">{{errorMessage}}</span>
                    </v-col>
                </v-row>
                <v-text-field
                    v-model="deliveryAddress.addressLine1"
                    outlined
                    prepend-inner-icon="home"
                    :rules="[required('Address')]"
                    label="Address Line 1"
                ></v-text-field>
                <v-text-field
                    v-model="deliveryAddress.addressLine2"
                    outlined
                    prepend-inner-icon="home"
                    label="Address Line 2"
                ></v-text-field>
                <v-text-field
                    v-model="deliveryAddress.addressLine3"
                    prepend-inner-icon="home"
                    outlined
                    label="Address Line 3"
                ></v-text-field>
                <v-text-field
                    v-model="deliveryAddress.addressLine4"
                    prepend-inner-icon="home"
                    outlined
                    label="Address Line 4"
                ></v-text-field>
                <v-text-field
                    v-model="deliveryAddress.postcode"
                    outlined
                    prepend-inner-icon="home"
                    :rules="[required('PostCode'), isPostCode]"
                    :disabled="disablePostcode"
                    label="PostCode"
                ></v-text-field>
            </v-card-text>
          </v-col>
        </v-row>

        <v-card-actions v-if="isRegisteringUser || $store.getters.retrieveAnon">
          <v-spacer />
          <v-btn
            type="submit"
            color="primary"
            @click.stop="onRegister"
            :disabled="!valid"
            :loading="loading"
          >Submit</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer />
          <v-btn
            type="submit"
            color="primary"
            @click.stop="onRegister"
            :disabled="!valid"
            :loading="loading"
          >Update</v-btn>
        </v-card-actions>
        </v-form>
    </v-card>
</template>
<script>
import checkPostCode from "@/util/validation/postcode.js";
export default {
  name: "DeliveryInformation",

  props: ["deliveryAddress", "error", "errorMessage", "onRegister", "loading"],

  data: () => {
    return {
      valid: false,
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      isPostCode: (val) => {
        return checkPostCode(val);
      },
    };
  },
  computed: {
    isCncOnly() {
      return this.$store.state.user.cncOnly == "1";
    },
    cncAddressLine1() {
      return this.$store.state.configs.cnc_address_line_1;
    },
    cncAddressLine2() {
      return this.$store.state.configs.cnc_address_line_2;
    },
    cncAddressLine3() {
      return this.$store.state.configs.cnc_address_line_3;
    },
    cncAddressLine4() {
      return this.$store.state.configs.cnc_address_line_4;
    },
    cncPostcode() {
      return this.$store.state.configs.cnc_postcode;
    },
    cncTelephone() {
      return this.$store.state.configs.cnc_telephone;
    },
    isRegisteringUser() {
      return this.$route.name == "Registration";
    },
    disablePostcode() {
      if (
        (this.isRegisteringUser && this.deliveryAddress.postcode) ||
        this.$store.getters.retrieveAnon
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>